export default function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: "800px", margin: "40px auto", padding: "0 20px",
                  fontFamily: "Arial, sans-serif", lineHeight: "1.8", color: "#333" }}>
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> November 15, 2025</p>

      <p>
        Dropkart ("App"), operated by Dropkart India Pvt. Ltd ("Developer", "we", "our", or "us"),
        is committed to protecting your privacy and handling your personal information responsibly
        in accordance with applicable laws including the Information Technology Act, 2000 and
        applicable Indian Data Protection regulations.
      </p>

      {/* Developer Details Box */}
      <div style={{ background: "#f5f5f5", border: "1px solid #ddd", borderRadius: "8px",
                    padding: "16px 20px", margin: "20px 0" }}>
        <p style={{ margin: "4px 0" }}><strong>Application Name:</strong> Dropkart</p>
        <p style={{ margin: "4px 0" }}><strong>Developer Name:</strong> Dropkart India Pvt. Ltd</p>
        <p style={{ margin: "4px 0" }}><strong>Website:</strong>{" "}
          <a href="https://dropkart.net">https://dropkart.net</a></p>
        <p style={{ margin: "4px 0" }}><strong>Email:</strong>{" "}
          <a href="mailto:dropkartworld29@gmail.com">dropkartworld29@gmail.com</a></p>
        <p style={{ margin: "4px 0" }}><strong>Phone:</strong> +91 90322 25598</p>
      </div>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>Name, email address, phone number, and delivery address</li>
        <li>Order details and transaction information</li>
        <li>Payment-related information processed securely through authorized payment providers</li>
        <li>Device information, IP address, browser details, and usage analytics</li>
        <li>Location information when required for delivery services</li>
      </ul>

      <h2>2. How We Use Your Data</h2>
      <ul>
        <li>Processing and fulfilling orders</li>
        <li>Managing customer accounts</li>
        <li>Providing delivery updates</li>
        <li>Customer support and service improvement</li>
        <li>Fraud detection and prevention</li>
        <li>Legal and regulatory compliance</li>
        <li>Marketing communications (only with your consent where applicable)</li>
      </ul>

      <h2>3. Sharing of Data</h2>
      <p>We may share information with:</p>
      <ul>
        <li>Payment gateway providers</li>
        <li>Delivery and logistics partners</li>
        <li>Customer support providers</li>
        <li>Government authorities when required by law</li>
      </ul>
      <p>We do not sell personal information to third parties.</p>

      <h2>4. Data Security</h2>
      <p>
        We implement reasonable technical and organizational safeguards, including encryption,
        SSL-secured communications, access controls, and secure servers to protect personal information.
      </p>

      <h2>5. Your Rights</h2>
      <p>Subject to applicable laws, you may request:</p>
      <ul>
        <li>Access to your personal information</li>
        <li>Correction of inaccurate information</li>
        <li>Deletion of personal information</li>
        <li>Withdrawal of consent where applicable</li>
      </ul>

      <h2>6. Data Safety (Google Play)</h2>
      <ul>
        <li><strong>Data collected:</strong> Name, email, phone, address, order history, device identifiers</li>
        <li><strong>Data shared:</strong> With payment and delivery partners only</li>
        <li><strong>Encryption:</strong> All data encrypted in transit via SSL/TLS</li>
        <li><strong>Deletion:</strong> Email us to request data deletion</li>
        <li><strong>Children:</strong> This app is not directed at children under 13</li>
      </ul>

      <h2>7. Fraud Prevention &amp; Order Validation</h2>
      <p>
        Dropkart reserves the right to verify, cancel, hold, or reject orders in cases involving
        suspected fraud, payment manipulation, price tampering, unauthorized access, technical
        misuse, or activities that compromise platform integrity.
      </p>
      <p>
        If abnormal pricing, incorrect order values, or attempts to manipulate the platform are
        detected, we may cancel the order and take appropriate technical, legal, or administrative
        action. The customer agrees that Dropkart's decision in such situations is final and binding.
      </p>

      <h2>8. Data Retention</h2>
      <p>
        We retain personal information only as long as necessary to provide services, comply with
        legal obligations, resolve disputes, and enforce agreements.
      </p>

      <h2>9. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Updated versions will be published
        within the application and on our website.
      </p>

      <h2>10. Contact Us</h2>
      <p><strong>Developer:</strong> Dropkart India Pvt. Ltd</p>
      <p><strong>Website:</strong>{" "}
        <a href="https://dropkart.net">https://dropkart.net</a></p>
      <p><strong>Email:</strong>{" "}
        <a href="mailto:dropkartworld29@gmail.com">dropkartworld29@gmail.com</a></p>
      <p><strong>Phone:</strong> +91 90322 25598</p>
    </div>
  );
}